const SvgStorage1 = (props) => (
  <>
    <defs />
    <circle cx={48} cy={160} r={8} fill="#042068" strokeWidth={0} />
    <circle cx={48} cy={64} r={8} fill="#2666f4" strokeWidth={0} />
    <circle cx={112} cy={160} r={8} fill="#2666f4" strokeWidth={0} />
    <circle cx={48} cy={256} r={8} fill="#042068" strokeWidth={0} />
    <circle cx={112} cy={256} r={8} fill="#042068" strokeWidth={0} />
    <circle cx={176} cy={256} r={8} fill="#2666f4" strokeWidth={0} />
    <circle cx={176} cy={160} r={8} fill="#2666f4" strokeWidth={0} />
    <circle cx={240} cy={256} r={8} fill="#042068" strokeWidth={0} />
    <circle cx={48} cy={352} r={8} fill="#2666f4" strokeWidth={0} />
    <circle cx={112} cy={352} r={8} fill="#042068" strokeWidth={0} />
    <circle cx={176} cy={352} r={8} fill="#2666f4" strokeWidth={0} />
    <circle cx={240} cy={352} r={8} fill="#042068" strokeWidth={0} />
    <circle cx={304} cy={352} r={8} fill="#2666f4" strokeWidth={0} />
    <circle cx={112} cy={64} r={8} fill="#042068" strokeWidth={0} />
    <path
      d="M384 320v64H0v-64M0 224v64h384v-64M0 128v64h384v-64"
      fill="none"
      stroke="#042068"
      strokeMiterlimit={10}
      strokeWidth="3px"
    />
    <path id="b" d="M0 32v64h384V32" fill="none" stroke="#042068" strokeMiterlimit={10} strokeWidth="3px" />
  </>
);

export default SvgStorage1;
